import { ContactService } from '@/services/contacts.service';
import { ContactFilters } from '@/types/filters/contact';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const listContactsQuery = (filters?: ContactFilters) => queryOptions({
  queryKey: ['list-contacts', filters],
  queryFn: () => ContactService.list(filters),
  placeholderData: keepPreviousData,
});